import WarningIcon from '@icons/warning_16.svg?react';

export interface IModelDocumentation {
  doc: string;
}

export function ModelDocumentation({ doc }: IModelDocumentation) {
  return (
    <div className="flex items-center text-base mb-3">
      <div className="w-[25px] h-[25px] flex items-center mr-3">
        <WarningIcon data-testid="warning-icon" />
      </div>{' '}
      <div>{doc}</div>
    </div>
  );
}
